import { VSpacer } from "@/components/DesignSystem";
import SubwalletList from "@/pages/Admin/HierarchyOfRetailers/Wallet/SubwalletList";
import { SubwalletEndpoint } from '@api/endpoints';
import { ApiManufacturer, ApiRetailer } from '@api/interfaces';
import { Stack } from "@mui/material";
import { DemoBlock } from "../../components/DemoBlock";
import { DemoContainer } from "../../components/DemoContainer";
import { ApiRedemptionSkuProduct } from "@api/interfaces/ApiRedemptionSkuProduct";

const demoSubwalletData: SubwalletEndpoint.List.ResolvedApiSubwalletListItem[] =[
  {
    createdAt: new Date(),
    redeemableProductsDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris 
        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
        culpa qui officia deserunt mollit anim id est laborum.`,
    id: '1',
    manufacturer: null,
    manufacturerId: null,
    retailer: { name: 'Amherst Ag Supply' } as ApiRetailer,
    retailerId: 'retailer-id',
    updatedAt: new Date(),
    skuProducts: [
      { externalId: 'sku-1', name: "SKU 1" } as ApiRedemptionSkuProduct,
      { externalId: 'sku-2', name: "SKU 2" } as ApiRedemptionSkuProduct,
    ],
    name: "Amherst Ag Loyalty Points",
  },
  {
    createdAt: new Date(),
    redeemableProductsDescription: `reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
        culpa qui officia deserunt mollit anim id est laborum.`,
    id: '2',
    manufacturer: { name: 'Bayer' } as ApiManufacturer,
    manufacturerId: 'manufacturer-id',
    retailer: { name: 'Amherst Ag Supply' } as ApiRetailer,
    retailerId: 'retailer-id',
    updatedAt: new Date(),
    skuProducts: [],
    name: "Bayer",
  },
];

export const SubwalletListDemo = () => {
  return (
    <>
      <DemoBlock label="Wallet List Empty Variant">
        <Stack alignItems="center" spacing={2}>
          <DemoContainer
            backgroundColor="background.default"
            padding={2}
          >
            <SubwalletList subwallets={[]} />
          </DemoContainer>
        </Stack>
      </DemoBlock>
      <VSpacer size="8" />
      <DemoBlock label="Wallet List Multiple Rows Variant">
        <Stack alignItems="center" spacing={2}>
          <DemoContainer
            backgroundColor="background.default"
            padding={2}
          >
            <SubwalletList subwallets={demoSubwalletData} />
          </DemoContainer>
        </Stack>
      </DemoBlock>
    </>
  );
};
